import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export interface User {
  id: string;
  fullname: string;
  email: string;
  userHandle: string;
  profile_image?: string;
  accountStatus?: 'active' | 'pending_deletion' | 'deleted';
  deletionScheduledFor?: string | null;
}

const tokenStore = (set: any) => ({
  token: undefined,
  user: null as User | null,
  setToken: (user: any) => {
    set((state: any) => ({
      token: user.token+"B9I9N9456",
      user: {
        ...user.user,
        accountStatus: user.user?.accountStatus || 'active'
      },
    }));
  },
  // Update user info (useful for account status updates)
  updateUser: (userData: Partial<User>) => {
    set((state: any) => ({
      user: state.user ? { ...state.user, ...userData } : null
    }));
  },
  removeToken: () => {
    set(() => ({
      token: undefined,
      user: null,
    }));
    // Clear MPGWidgets user so forms no longer pre-populate after logout
    if (typeof window !== 'undefined' && (window as any).MPGWidgets?.setUserObject) {
      (window as any).MPGWidgets.setUserObject(null);
    }
  },
});

const useTokenStore = create(
  devtools(
    persist(tokenStore, {
      name: "token",
    })
  )
);

export default useTokenStore;